import React from 'react';
import { Building2, Home, Car, Scale, Dumbbell, Sparkles, Heart } from 'lucide-react';
import { CharReveal, Reveal } from './TerminalEffects';

const ACCENTS = ['#00FFD1', '#C4956A', '#7DFFD4', '#D4F7DC', '#00FFD1', '#C4956A', '#7DFFD4', '#D4F7DC'];

const INDUSTRIES = [
  { icon: Building2, name: 'Healthcare', description: 'Streamline patient appointments, manage referrals, and provide 24/7 support to patients and staff.' },
  { icon: Home, name: 'Real Estate', description: 'Qualify leads, schedule viewings, and follow up with potential buyers or tenants instantly.' },
  { icon: Building2, name: 'Hospitality', description: 'Manage reservations, handle guest queries, and ensure every guest feels valued around the clock.' },
  { icon: Car, name: 'Automotive', description: 'Book service appointments, manage test drives, and handle customer enquiries with ease.' },
  { icon: Scale, name: 'Legal', description: 'Screen potential clients, schedule consultations, and manage intake forms with precision.' },
  { icon: Dumbbell, name: 'Fitness', description: 'Handle membership inquiries, book classes, and manage personal training schedules effortlessly.' },
  { icon: Sparkles, name: 'Beauty & Wellness', description: 'Manage salon bookings, send appointment reminders, and handle client follow-ups automatically.' },
  { icon: Heart, name: 'Wellbeing', description: 'Schedule therapy sessions, manage client intake, and provide compassionate, automated support.' },
];

export const IndustriesSection = () => (
  <section className="relative overflow-hidden" data-testid="industries-section">
    <div className="absolute inset-x-0 top-0 h-1/2 bg-[#D4F7DC]" />
    <div className="absolute inset-x-0 bottom-0 h-1/2 bg-[#2A2A2A]" />

    {/* Grid pattern */}
    <div className="absolute inset-x-0 top-[20%] bottom-0 z-[1] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,255,209,0.12) 1px, transparent 0), repeating-linear-gradient(0deg, transparent, transparent 39px, rgba(0,255,209,0.05) 39px, rgba(0,255,209,0.05) 40px), repeating-linear-gradient(90deg, transparent, transparent 39px, rgba(0,255,209,0.05) 39px, rgba(0,255,209,0.05) 40px)',
      backgroundSize: '40px 40px',
    }} />
    <div className="absolute inset-x-0 top-[20%] h-24 z-[2] pointer-events-none" style={{ background: 'linear-gradient(to bottom, #D4F7DC, transparent)' }} />

    <div className="relative z-10 py-28 max-w-[1200px] mx-auto px-6 lg:px-8">
      <Reveal>
        <div className="mb-20 max-w-[600px]">
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C4956A] mb-4">Industries We Serve</p>
          <CharReveal text="Trusted Across Multiple Industries" tag="h2"
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#2A2A2A] leading-[1.05]" />
        </div>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {INDUSTRIES.map((ind, i) => {
          const Icon = ind.icon;
          return (
            <Reveal key={ind.name} delay={i * 80}>
              <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 group hover:bg-[#2A2A2A] hover:translate-y-[-4px] hover:shadow-[0_8px_30px_rgba(0,0,0,0.3)] transition-all duration-300 cursor-default relative overflow-hidden border border-[#2A2A2A]/5 h-full flex flex-col"
                data-testid={`industry-card-${i}`}>
                <div className="mb-4">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center transition-colors" style={{ backgroundColor: `${ACCENTS[i]}20` }}>
                    <Icon size={18} style={{ color: ACCENTS[i] }} className="group-hover:scale-110 transition-transform" />
                  </div>
                </div>
                <h3 className="text-base font-semibold text-[#2A2A2A] group-hover:text-[#F5F0E0] mb-2 transition-colors"
                  style={{ fontFamily: "'Outfit', sans-serif" }}>{ind.name}</h3>
                <p className="text-xs text-[#2A2A2A]/60 group-hover:text-[#F5F0E0]/60 leading-relaxed transition-colors flex-1"
                  style={{ fontFamily: "'Manrope', sans-serif" }}>{ind.description}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
